import { render, staticRenderFns } from "./TransitionClientReviewAndFinish.vue?vue&type=template&id=a8b68068&scoped=true"
import script from "./TransitionClientReviewAndFinish.vue?vue&type=script&lang=js"
export * from "./TransitionClientReviewAndFinish.vue?vue&type=script&lang=js"
import style0 from "./TransitionClientReviewAndFinish.vue?vue&type=style&index=0&id=a8b68068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b68068",
  null
  
)

export default component.exports